export const formatRXName = (name: string): string =>
  name.replace(/\\r\\n/g, ' - ')
